import axios from "axios";
import React, { useCallback, useState } from "react";

import { Form, Formik } from "formik";
// import "react-phone-input-2/lib/material.css";
import { useDispatch, useSelector } from "react-redux";

import { useLocalStorage } from "../../hooks";
import * as dashboardActions from "../../redux/reducers/dashboardReducer";
import * as schoolActions from "../../redux/reducers/schoolReducer";
import * as userActions from "../../redux/reducers/userReducer";
import { userState } from "../../redux/reducers/userReducer";


import { EyeIcon, EyeSlashIcon } from "@heroicons/react/20/solid";
import { useGoogleLogin } from "@react-oauth/google";
import lock_img from "../../assets/password.svg";
import BZLogo from "../../components/BZLogo";
import { TwInputGroup, TwMainLayout, TwPhoneInputGroup } from "../../components/tailwind";
import { useToast } from "../../provider/ToastProvider";
import { loadingState, setActionLoading } from "../../redux/reducers/loadingReducer";
import { getDomainUrl, getTenantDomainUrl, getUrlForUsers, isRootDomain, redirectWithwwwRootDomain } from "../../utils/confighelpers";
import { DEFAULT_TENANT, useTenant } from "../../provider/TenantProvider";
import { defaultDomainList, ignoreDomainList } from "../../utils/constants";
import { classNames, getRootDomain } from "../../helpers";
import { useLocation } from "react-router-dom";
import { getOnboardingRedirect, ONBOARDING_ROUTES } from "../../utils/onboarding";
import VerifyTempPassword, { needsVerification } from "./VerifyTempPassword";
import JoinClubDialog from "./JoinClubDialog";
import AuthShell, { AuthHeading, GoogleButton, OrDivider, PrimaryAuthButton } from "../../components/auth/AuthShell";

export default function SignIn({ navigation }) {
  const { addToast, addSuccessToast, addErrorToast, addNotificationDialog, addConfirmDialog } = useToast();
  const { tenant, tenantData, tenantLoading } = useTenant();
  const location = useLocation();
  const urlParams = new URLSearchParams(window.location.search);
  const dispatch = useDispatch();
  const loadingReduxState = useSelector(loadingState);
  const userReduxState = useSelector(userState);
  const [userToken, setUserToken] = useLocalStorage("userToken");
  const [passwordVisible, setPasswordVisible] = React.useState(false);
  const [selectedUserType, setSelectedUserType] = useState(0)
  /** Set when a login used a temporary password: the member verifies their number and sets a password first (as in the apps). */
  const [verifyArgs, setVerifyArgs] = useState(null)
  /** Why a Google sign-in didn't go through (e.g. a club-added member who hasn't activated yet), shown above the button. */
  const [socialNotice, setSocialNotice] = useState("")
  /** Signed in on a club's address without being a member of that club: offer to join it (or go to their own club). */
  const [joinOffer, setJoinOffer] = useState(null)

  /** Member is a member of this club: sign them in and go to the schedule (or returnurl). */
  const finishMemberLogin = (userData, values) => {
    setUserToken(userData.token);
    dispatch(userActions.setUserData(userData));
    if (values) {
      dispatch(userActions.setUserPhone(values.formattedPhoneNumber));
    }
    dispatch(userActions.setBusinessType("class"));
    let returnurl = urlParams.get('returnurl')
    navigation(returnurl && returnurl !== "" ? returnurl : "/members/schedule");
  };

  const onLoginStart = useCallback(() => { }, []);
  const onLogin = async (body, values = null, setSubmitting = () => { }, options = {}) => {
    dispatch(setActionLoading(true));
    const config = {
      method: "post",
      url: `${getUrlForUsers()}loginUser`,
      data: body,
    };
    try {
      const request = await axios(config);
      dispatch(setActionLoading(false));
      if (request.status === 200) {
        /** Temporary password: 200 with isVerified:false and no token. Run the verify + new password journey instead. */
        if (!body.socialType && needsVerification(request.data)) {
          setSubmitting(false);
          if (options.fromVerification) return false; // never loop back into the journey
          setVerifyArgs({
            username: body.username,
            userType: body.userType,
            fullName: request.data.data?.fullName,
            message: request.data.message,
            displayNumber: values?.formattedPhoneNumber || body.username,
            values,
          });
          return;
        }
        if (request.data.statusCode !== 200) {
          if (body.socialType) setSocialNotice(request.data.message || "");
          else addErrorToast(request.data.message);
          setSubmitting(false);
          return false;
        } else {

          let userData = request.data.data

          if (userData.userType == "student") {
            setSubmitting(false);
            /** validate user **/
            let validateUser = true
            let clubFound = {};
            if ((userData.myClubs || []).length == 0) {
              validateUser = false
            } else if ((userData.myClubs || []).length > 0) {
              if (tenantLoading == false && (!tenantData.businessId || tenantData.businessId == "")) {

                console.log("tenantData.businessId", tenantData.businessId);
                validateUser = false
              } else if (tenantData?.businessId != undefined && tenantData?.businessId != "") {
                clubFound = (userData.myClubs || []).find((f) => f.businessId == tenantData?.businessId)
                // console.log("clubFound", clubFound);

                if (Object.keys(clubFound || {}).length == 0) {
                  validateUser = false
                }
              } else {
                validateUser = false
              }
            }

            if (validateUser == false) {

              const onClubAddress = tenantLoading == false && tenantData?.businessId != undefined && tenantData?.businessId != "";
              if (onClubAddress) {
                setJoinOffer({
                  userData,
                  values,
                  clubName: tenantData?.businessName || "this club",
                  clubLink: tenantData?.business_details?.myBookingLink || tenant,
                });
                return;
              }

              if ((userData.myClubs || []).length <= 0) {

                addNotificationDialog({
                  dialogType: "error",
                  dialogTitle: "Member not found!",
                  // dialogMessage: "You are not registered as a member of this club/gym.",
                  dialogMessage: `We found your account, but it’s not linked to ${tenantData?.businessName || "club"}. Please contact your club admin.`,
                  dialogBtnTitle: "Ok",
                  isAllowBackdropClick: false,
                  isDialogBtnShow: true,
                  dialogBtnClick: async () => {

                  },
                })
              } else {

                addConfirmDialog({
                  dialogType: "info",
                  dialogTitle: "Member not found!",
                  dialogMessage: `We found your account, but it’s not linked to ${tenantData?.businessName || "club"}. Want me to find your club and take you to its login page?`,
                  btnCloseText: "Cancel",
                  btnConfirmText: "Yes, take me there",
                  onClose: () => {
                  },
                  onConfirm: () => {
                    let newclubFound = (userData.myClubs || []).find((f) => f.businessId != "")
                    console.log("newclubFound", newclubFound);
                    if (newclubFound && newclubFound?.myBookingLink) {
                      // console.log("newclubFound", newclubFound);

                      // let businessDomain = window.location.protocol + `//${tenantData?.business_details?.myBookingLink.replace(tenantData?.business_details?.appUrl,"")}.` + getRootDomain()
                      let businessDomain = window.location.protocol + `//${newclubFound?.myBookingLink}.` + getRootDomain()
                      // console.log("tenantData", tenantData?.business_details);
                      // let businessDomain = getTenantDomainUrl(tenantData?.business_details)
                      // alert(businessDomain)
                      window.location.href = businessDomain;
                    }
                  },
                });
                // addNotificationDialog({
                //   dialogType: "error",
                //   dialogTitle: "Member not found!",
                //   // dialogMessage: "You are not registered as a member of this club/gym.",
                //   dialogMessage: `We found your account, but it’s not linked to ${tenantData?.businessName || "club"}. Want me to find your club and take you to its login page?`,
                //   dialogBtnTitle: "Ok",
                //   isAllowBackdropClick: false,
                //   isDialogBtnShow: true,
                //   dialogBtnClick: async () => {

                //   },
                // })

              }
              return;
            }

            setUserToken(request.data.data.token);
            dispatch(userActions.setUserData(request.data.data));
            if (values) {
              dispatch(
                userActions.setUserPhone(values.formattedPhoneNumber)
              );
            }

            dispatch(userActions.setBusinessType("class"));
            dispatch(userActions.setUserData(userData));
            let returnurl = urlParams.get('returnurl')
            navigation(returnurl && returnurl !== "" ? returnurl : "/members/schedule");
            return;
          }
          /** Teachers mode **/
          setUserToken(request.data.data.token);
          dispatch(userActions.setUserData(request.data.data));
          if (values) {
            dispatch(
              userActions.setUserPhone(values.formattedPhoneNumber)
            );
          }

          /** New onboarding order: resume at the plan or the welcome/club-details step when needed */
          const onboardingRedirect = getOnboardingRedirect(userData);
          if (onboardingRedirect) {
            dispatch(userActions.setOnBoardingData({
              ...userReduxState && userReduxState.onBoardingData && Object.keys(userReduxState.onBoardingData).length > 0 ? userReduxState.onBoardingData : {},
              ...userData,
              name: userData.fullName,
            }));
            setSubmitting(false);
            navigation(onboardingRedirect);
            return;
          }

          /** Owner who hasn't finished onboarding but isn't sent anywhere above (account not confirmed yet).
           *  The old wizard (/on-bording) is gone (2026-10-28): Google sign-ins with a new email are registered by
           *  the backend and go through the same onboarding as phone sign-ups (getOnboardingRedirect -> /start/plan). */
          if ((userData.onBoardingStep || 0) < 3) {
            setSubmitting(false);
            navigation(userData.isVerified === false ? "/" : ONBOARDING_ROUTES.plan);
            return;
          } else if (userData.onBoardingStep >= 3) {
            dispatch(
              schoolActions.setId(request.data.data?.schoolObj?.id || request.data.data?._id)
            );
            dispatch(
              schoolActions.setName(
                request.data.data?.schoolObj?.schoolName || request.data.data?.myBusinessProfile.businessName
              )
            );
            dispatch(
              schoolActions.setLogo(request.data.data?.schoolObj?.logo || request.data.data?.myBusinessProfile.logo)
            );
            dispatch(
              schoolActions.setCategories(
                request.data.data.seletedCategories
              )
            );
            setSubmitting(false);
            dispatch(dashboardActions.setCalendarOpen(false));
            navigation("/home/dashboard");
          }
          setSubmitting(false);
        }
      }
    } catch (error) {
      console.log("error", error);
      dispatch(setActionLoading(false));
      setSubmitting(false);
      addErrorToast("Something went wrong while signing you in. Please try again.");
      return false;
    }
  };

  const googleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      console.log(tokenResponse);
      const userInfo = await axios.get(
        'https://www.googleapis.com/oauth2/v3/userinfo',
        { headers: { Authorization: `Bearer ${tokenResponse.access_token}` } },
      );

      console.log(userInfo);
      const body = {
        username: userInfo.data.email,
        password: "",
        appToken: "k4zJNUAAv9eGQbZXuZf0SPMnuhr6vXfl",
        deviceType: "Web",
        userType: selectedUserType == 0 ? "student" : "teacher",
        socialType: 'google',
        socialToken: tokenResponse.access_token,
        socialData: {
          ...JSON.parse(JSON.stringify({
            ...userInfo.data,
            ...tokenResponse,
            provider: 'google',
          })),
        },
      };

      console.log("onResolve body", body);
      await onLogin(body);
    },
    onError: errorResponse => console.log(errorResponse),
  });

  React.useEffect(() => {
    if (userToken !== undefined && userToken !== "" && userReduxState.userData?.fullName) {
      if (userReduxState.userData?.userType == "student") {
        navigation("/members/schedule");
      } else {
        window.location.href = "/home/dashboard";
      }
    }
    dispatch(setActionLoading(false));
  }, []);

  React.useEffect(() => {
    if (defaultDomainList.indexOf(tenant) >= 0) {
      setSelectedUserType(1)
      // window.location.href = `${getDomainUrl()}signup`;
    } else if (tenantLoading == false && (!tenantData.businessName || !tenantData.logo || tenantData.businessName == "DEFAULT" || tenantData.businessName == "NOTFOUND")) {
      addNotificationDialog({
        dialogType: "error",
        dialogTitle: "Club not found!",
        dialogMessage: "This club/gym is not registered on FitClub.",
        dialogBtnTitle: "Create your club account",
        isAllowBackdropClick: false,
        isDialogBtnShow: true,
        dialogBtnClick: async () => {
          window.location.href = `${getDomainUrl()}signup`;
        },
      })
    }
    if (tenantData?.businessName != undefined && tenantData?.businessName != ""
      && tenantData.logo != undefined && tenantData.logo != ""
      && tenantData.businessName != "DEFAULT" && tenantData.businessName != "NOTFOUND") {
      setSelectedUserType(0)

      if (location?.pathname && location.pathname !== "/members/signin") {
        if ((userToken === undefined || userToken == "")) {
          window.location.href = "/members/signin";
        }
      }
    }
  }, [tenantLoading, tenantData]);

  if (defaultDomainList.indexOf(tenant) >= 0) {
    // allow for sigin
  } else if (((tenantLoading == false && (!tenantData.businessName || !tenantData.logo || tenantData.businessName == "DEFAULT" || tenantData.businessName == "NOTFOUND")))) {
    if (isRootDomain()) {
      console.log("Root domain (no subdomain)");
      redirectWithwwwRootDomain()
    }
    return ("")
  }

  const isAdminDomain = defaultDomainList.indexOf(tenant) >= 0;
  const clubName = tenantData?.businessName || "your club";

  return (
    <TwMainLayout fullScreen={true} checkSession={false}>
      <AuthShell club={!isAdminDomain && tenantData?.business_details ? tenantData.business_details : null} brandTitle="Welcome back.">
        <JoinClubDialog
          offer={joinOffer}
          onClose={() => setJoinOffer(null)}
          onJoined={(fresh) => {
            const values = joinOffer?.values;
            setJoinOffer(null);
            finishMemberLogin(fresh, values);
          }}
        />
        {!userToken && verifyArgs && (
          <VerifyTempPassword
            username={verifyArgs.username}
            userType={verifyArgs.userType}
            fullName={verifyArgs.fullName}
            displayNumber={verifyArgs.displayNumber}
            message={verifyArgs.message}
            onCancel={() => setVerifyArgs(null)}
            onSignIn={(newPassword) => onLogin(
              {
                username: verifyArgs.username,
                password: newPassword,
                appToken: "k4zJNUAAv9eGQbZXuZf0SPMnuhr6vXfl",
                deviceType: "Web",
                userType: verifyArgs.userType,
              },
              verifyArgs.values,
              () => { },
              { fromVerification: true }
            )}
          />
        )}

        {!userToken && !verifyArgs && (
          <div className="flex flex-col gap-6">
            {isAdminDomain ? (
              <AuthHeading eyebrow="CLUB ADMIN" title="Sign in to your club">Use the mobile number you signed up with.</AuthHeading>
            ) : (
              <AuthHeading eyebrow="MEMBER SIGN-IN" title="Welcome back">
                Sign in to book your next class at {clubName}. New member? Use the Activate button in your welcome email first.
              </AuthHeading>
            )}

            {socialNotice && (
              <div role="alert" className="flex items-start gap-3 rounded-2xl border border-[#F5D7A8] bg-[#FFF4E5] px-4 py-3.5">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#8A4B00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mt-0.5 shrink-0" aria-hidden="true">
                  <circle cx="12" cy="12" r="9" /><path d="M12 8v5" /><path d="M12 16h.01" />
                </svg>
                <p className="text-sm leading-relaxed text-[#5A3200]">{socialNotice}</p>
                <button type="button" onClick={() => setSocialNotice("")} aria-label="Close" className="-mr-1 ml-auto shrink-0 rounded-lg p-1 text-[#8A4B00] hover:bg-[#FBE5C4]">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" /></svg>
                </button>
              </div>
            )}

            <GoogleButton onClick={() => { setSocialNotice(""); googleLogin(); }} />
            <OrDivider>or sign in with your mobile</OrDivider>

            <Formik
              initialValues={{
                countryName: "nl",
                countryCode: "",
                phone: "",
                formattedPhoneNumber: "",
                password: "",
              }}
              validate={(values) => {
                const errors = {};
                if (!values.phone) {
                  errors.phone = "Required!";
                }
                if (!values.password) {
                  errors.password = "Required!";
                }
                return errors;
              }}
              onSubmit={async (values, { setSubmitting }) => {
                let phoneNumber = values.formattedPhoneNumber.split(" ");
                phoneNumber = phoneNumber.join("");
                phoneNumber = phoneNumber.replace(" ", "");
                phoneNumber = phoneNumber.replace("-", "");
                setSubmitting(false);
                const body = {
                  username: phoneNumber,
                  password: values.password,
                  appToken: "k4zJNUAAv9eGQbZXuZf0SPMnuhr6vXfl",
                  deviceType: "Web",
                  userType: selectedUserType == 0 ? "student" : "teacher",
                };

                await onLogin(body, values, setSubmitting);
              }}
            >
              {({
                values,
                setFieldValue,
                errors,
                touched,
                handleBlur,
                submitForm,
                isSubmitting,
              }) => (
                <Form onSubmit={(e) => {
                  e.preventDefault();
                  submitForm();
                  return false;
                }} className="flex flex-col gap-5">
                  <TwPhoneInputGroup
                    label={"Mobile number"}
                    placeholder={"Mobile number"}
                    name={"phone"}
                    country={values.countryName}
                    onBlur={() => handleBlur("phone")}
                    onChange={(phone, country, e) => {
                      const numberWithoutDialCode = phone.split("");
                      for (let i = 0; i < country.dialCode.length; i++) {
                        numberWithoutDialCode.shift();
                      }
                      setFieldValue("countryName", country.countryCode);
                      setFieldValue("countryCode", country.dialCode);
                      setFieldValue("phone", numberWithoutDialCode.join(""));
                      setFieldValue("formattedPhoneNumber", e.target.value);
                    }}
                    errors={touched["phone"] ? errors : {}}
                  />
                  <div>
                    <TwInputGroup
                      label={"Password"}
                      placeholder={"Your password"}
                      name={"password"}
                      type={passwordVisible ? "text" : "password"}
                      leftIcon={(<img className={""} src={lock_img} alt={""} />)}
                      rightIcon={
                        <button type="button" className="flex" aria-label={passwordVisible ? "Hide password" : "Show password"} onClick={() => setPasswordVisible(!passwordVisible)}>
                          {passwordVisible ? <EyeIcon className="size-5" /> : <EyeSlashIcon className="size-5" />}
                        </button>
                      }
                      onChange={(e) => {
                        setFieldValue("password", e.target.value);
                      }}
                      errors={touched["password"] ? errors : {}}
                    />
                    <div className="mt-2 text-right">
                      <button
                        type="button"
                        className="text-sm font-extrabold text-indigo-bz hover:underline"
                        onClick={() => navigation(`/forgot-password${selectedUserType == 0 ? "/member" : ""}`)}
                      >
                        Forgot password?
                      </button>
                    </div>
                  </div>
                  <PrimaryAuthButton busy={loadingReduxState.actionLoading || isSubmitting}>Sign in</PrimaryAuthButton>
                  <p className="text-center text-[15px] text-gray-600">
                    {isAdminDomain ? "New to FitClub?" : "Not a member yet?"}{" "}
                    <button
                      type="button"
                      className="font-extrabold text-indigo-bz hover:underline"
                      onClick={() => {
                        if (selectedUserType == 0) {
                          navigation(`/members/signup`)
                        } else {
                          navigation(`/signup`)
                        }
                      }}
                    >
                      {isAdminDomain ? "Create your club account" : `Join ${clubName}`}
                    </button>
                  </p>
                </Form>
              )}
            </Formik>
          </div>
        )}
      </AuthShell>
    </TwMainLayout>)
}
